module.exports = __webpack_public_path__ + "./images/95748f2cbe989d8a326fcb2b8bbc77f9.webp";